import bg from '../assets/bg.png';
import chef from '../assets/chef.png';
import G from '../assets/G.png';
import gallery01 from '../assets/gallery01.png';
import gallery02 from '../assets/gallery02.png';
import gallery03 from '../assets/gallery03.png';
import gallery04 from '../assets/gallery04.png';
import gallery05 from '../assets/gallery05.png';
import gallery06 from '../assets/gallery06.png';
import gallery07 from '../assets/gallery07.png';
import gallery08 from '../assets/gallery08.png';
import gallery09 from '../assets/gallery09.png';
import gallery10 from '../assets/gallery10.png';
import gallery11 from '../assets/gallery11.png';
import gallery12 from '../assets/gallery12.png';
import gallery13 from '../assets/gallery13.png';
import gallery14 from '../assets/gallery14.png';
import gallery15 from '../assets/gallery15.png';


import knife from '../assets/knife.png';
import logo from '../assets/logo.png';
import menu from '../assets/menu.png';
import overlaybg from '../assets/overlaybg.png';
import spoon from '../assets/spoon.svg';
import welcome from '../assets/welcome.png';
import findus from '../assets/urja_logo_white.png';
import sign from '../assets/sign.png';
import quote from '../assets/quote.png';
import gericht from '../assets/gericht.png';
import slider1 from '../assets/slider1.jpg';
import slider2 from '../assets/slider2.jpg';
import slider3 from '../assets/slider3.jpg';
import slider4 from '../assets/slider4.jpg';
import slider5 from '../assets/slider5.jpg';
import slider6 from '../assets/slider6.jpg';
import slider7 from '../assets/slider7.jpg';


const media = {
    bg,
    chef,
    G,
    gallery01,
    gallery02,
    gallery03,
    gallery04,
    gallery05,
    gallery06,
    gallery07,
    gallery08,
    gallery09,
    gallery10,
    gallery11,
    gallery12,
    gallery13,
    gallery14,
    gallery15,
    knife,
    logo,
    menu,
    overlaybg,
    spoon,
    welcome,
    findus,
    sign,
    quote,
    gericht,
    slider1,
    slider2,
    slider3,
    slider4,
    slider5,
    slider6,
    slider7
};

export default media;